import { render, staticRenderFns } from "./TargetConfirmDialog.vue?vue&type=template&id=45dd5b9f&"
import script from "./TargetConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./TargetConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports